<ng-container *ngIf="history(); else loader">
  <div
    matRipple
    class="chat"
    *ngFor="let chat of history()"
    [class.selected]="chat.id === selectedChatId()"
    (click)="onChatSelection(chat)">
    <div class="title">{{ chat.title }}</div>
    <div class="date">{{ chat.createdAt | transform: formatDate }}</div>

    <ng-container *ngIf="chat.id === selectedChatId()">
      <div class="actions">
        <q9-icon-button
          matTooltipPosition="below"
          (click)="deleteChat(chat.id)"
          matTooltip="{{ 'Delete' | translate }}"
          [disabled]="isCurrentChatDeleting()"
          [icon]="'delete-def'"></q9-icon-button>
      </div>
    </ng-container>
    <!-- NOTE: Statuses will be implemented later -->
    <!--    <ng-template #status>-->
    <!--      <ng-container *ngIf="chat.status!=='completed'">-->
    <!--        <div-->
    <!--             class="status"-->
    <!--             [matTooltip]="chat.error"-->
    <!--             matTooltipShowDelay="1000"-->
    <!--             [ngClass]="chat.status">-->
    <!--          {{ chat.status }}-->
    <!--        </div>-->
    <!--      </ng-container>-->
    <!--    </ng-template>-->
  </div>
</ng-container>

<ng-template #loader>
  <q9-content-loader></q9-content-loader>
</ng-template>
